export default "__VITE_ASSET__edf4ab56__"